var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkNestPurpleNegativeRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 930.11 181.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#7a5cf0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.89,511,217.81,630.89h-8.6l-36.79-78.11-36.79,78.11H127L75,511H101.7l30.82,76.68,35.6-79.31h8.6l36.07,78.36L243.13,511Z",
    transform: "translate(-74.95 -449.09)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326,508.34c34.17-.72,63.07,27.95,62.36,61.16.71,33.2-28.19,62.11-62.36,61.39-33.68.72-62.59-28.19-61.87-61.39C263.39,535.81,292.3,507.86,326,508.34Zm.24,22.93c-20.78,0-36.55,16.73-36.55,38.47s15.77,38,36.31,38c20.79,0,36.56-16.72,36.56-38C362.54,548,346.53,531.27,326.22,531.27Z",
    transform: "translate(-74.95 -449.09)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467.52,533.19h-7.64c-19.83,0-34.4,11.7-34.4,32.49v62.59H400.39V511H423.8v15.29A43.38,43.38,0,0,1,458,509.77a38.52,38.52,0,0,1,9.55,1.2Z",
    transform: "translate(-74.95 -449.09)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M478.12,449.09H503.2V628.27H478.12ZM584.91,628.27h-30.1l-50.89-65.94L549.79,511h31.06l-47.31,51.6Z",
    transform: "translate(-74.95 -449.09)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M729.82,577.86C732.92,597,748,608.68,768,608.68c12.18,0,23.65-4.54,34.16-13.86L814.15,612c-13.38,12.66-28.91,18.87-46.83,18.87-35.83,0-63.07-26.51-63.07-61.15-.71-33.69,27.48-62.12,60.68-61.4,31.06,0,54.23,23.17,54.23,53.75a74.35,74.35,0,0,1-1.91,15.77Zm64.26-19.59c-.24-17.92-13.62-28.67-30.1-28.67s-29.86,11.23-33.69,28.67Z",
    transform: "translate(-74.95 -449.09)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M838.89,592.43c10.27,10.75,20.54,16.72,33,16.72,10.75,0,18.88-4.53,18.88-13.13,0-6.93-5-9.8-16.49-14.58l-11.94-5c-20.78-8.6-30.58-17.68-30.58-34.17,0-21,17.44-33.92,41.33-33.92,17,0,30.34,6,40.61,18.16L900,542a38.19,38.19,0,0,0-27.47-11.95c-9.79,0-16,3.82-16,11.23,0,6,4.06,9.08,15.52,13.85l11.23,4.54c22.22,9.32,32,18.88,32,35.36,0,11.23-4.06,20.07-12.42,26.52-8.36,6.21-18.63,9.31-31.06,9.31-20.06,0-36.79-9.07-47.3-22.69Z",
    transform: "translate(-74.95 -449.09)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1005.05,628.27a102.81,102.81,0,0,1-20.78,2.62c-27,0-43.24-13.38-43.24-40.85V532.71H921.92V511H941V480.15h25.32V511h34.88v21.74H966.35v55.18c0,15.05,7.89,20.31,23.18,20.31,3.58,0,8.6-.48,15.52-1.2Z",
    transform: "translate(-74.95 -449.09)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 569.06,
    cy: 34.64,
    r: 22.56
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M644,511.59c-28.15,0-51,24.8-51,55.29v61.39h24.69V566.42c0-15.67,11.82-28.41,26.35-28.41s26.35,12.74,26.35,28.41v61.85h24.69V566.88C695.05,536.39,672.16,511.59,644,511.59Z",
    transform: "translate(-74.95 -449.09)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkNestPurpleNegativeRgb);
export default __webpack_public_path__ + "static/media/WorkNest_Purple_Negative_RGB.63b53830587b6849f164c29886924c39.svg";
export { ForwardRef as ReactComponent };